export enum Languages {
    en = "en",
    cs = "cs",
}
